/* eslint-disable */
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  Paper,
} from '@mui/material';
import SCB from '../../assets/images/SCB.png';
import BBL from '../../assets/images/BBL.png';
import BAY from '../../assets/images/BAY.png';

const InternetBankingPopup = ({ open, onClose }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelectOption = (option) => {
    setSelectedOption(option);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '900px',
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
            marginLeft: '20px',
          }}
        >
          ชำระเงินผ่าน Internet Banking
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            marginTop: '20px',
            marginBottom: '20px',
            marginLeft: '20px',
            marginRight: '20px',
          }}
        >
          <Grid container spacing={2}>
            {[
              {
                label: 'SCB',
                icon: (
                  <img
                    src={SCB}
                    alt="SCB"
                    style={{
                      width: 'auto',
                      marginTop: '2px',
                      marginBottom: '2px',
                    }}
                  />
                ),
              },
              {
                label: 'BBL',
                icon: (
                  <img
                    src={BBL}
                    alt="BBL"
                    style={{
                      width: 'auto',
                      marginTop: '2px',
                      marginBottom: '2px',
                    }}
                  />
                ),
              },
              {
                label: 'BAY',
                icon: (
                  <img
                    src={BAY}
                    alt="BAY"
                    style={{
                      width: 'auto',
                      marginTop: '2px',
                      marginBottom: '2px',
                    }}
                  />
                ),
              },
            ].map((option, index) => (
              <Grid item xs={6} md={4} key={index}>
                <Paper
                  elevation={3}
                  sx={{
                    padding: { xs: '15px', md: '25px' },
                    textAlign: 'center',
                    borderRadius: '15px',
                    cursor: 'pointer',
                    border:
                      selectedOption === option.label
                        ? '2px solid #0288d1'
                        : 'none',
                  }}
                  onClick={() => handleSelectOption(option.label)}
                >
                  {option.icon}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            marginTop: '20px',
            marginBottom: '20px',
            marginLeft: '20px',
            marginRight: '20px',
            fontSize: '14px',
          }}
        >
          การชำระเงินผ่าน Internet Banking / Cash Management
          อาจมีค่าบริการเรียกเก็บกับผู้ชำระเงินจากธนาคารเพิ่มเติม
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '40px',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              width: '100px', // Adjust the width as needed
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            // onClick={onClose}
            sx={{
              width: '100px', // Adjust the width as needed
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            ยืนยัน
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default InternetBankingPopup;
